// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { MailWarning } from '../../../commons/organisms/mail-warning';
import { VoucherTicketAmount, VoucherTicketDueDateTime } from '../commons/voucher/ticket';
import { NequiInstructions } from './nequi-instructions';
import { PaymentInstructions } from './payment-instructions';
import { HelpCenterInfo } from './help-center-info';
import { Separator } from '../../../commons/atoms';

export function NequiPageContent(): Node {

  return(
    <Root data-test-id="page-pending-payment">
      <NequiTitle>
        Pago NEQUI generado!
      </NequiTitle>

      <MailWarning />

      <PaymentInfoWrapper>
        <VoucherTicketAmount />
        <VoucherTicketDueDateTime />
      </PaymentInfoWrapper>

      <Separator direction="vertical" pattern="dotted" size={5} />

      <NequiInstructions />

      <Separator direction="vertical" pattern="dotted" size={5} />

      <PaymentInstructions />

      <HelpCenterInfo />

    </Root>
  );
}

const Root = styled.div``;

const NequiTitle = styled.p`
  font-size: 22px;
  font-family: ${props => props.theme.fontFamily.display};
  color: #2397d4;
  margin-bottom: 16px;
`;

const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 15px;
  border-radius: 5px;
  background-color: ${props => props.theme.colors.gray[0]};
`;
